import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { BusyService } from './busy.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  venueName$ = new BehaviorSubject<any>({});
  venueName = this.venueName$.asObservable();

  menuItems$ = new BehaviorSubject<any>([]);
  menuItems = this.menuItems$.asObservable();

  menuBCItem$ = new BehaviorSubject<any>({});
  menuBCItem = this.menuBCItem$.asObservable();

  ShowPasswordChange$ = new BehaviorSubject<any>({});
  ShowPasswordChange = this.ShowPasswordChange$.asObservable();

  useCounters$ = new BehaviorSubject<any>({});
  useCounters = this.useCounters$.asObservable();


  showSmallScreenMenu$ = new BehaviorSubject<any>({});
  showSmallScreenMenu = this.showSmallScreenMenu$.asObservable();

  kdsMode$ = new BehaviorSubject<boolean>(false);
  kdsMode = this.kdsMode$.asObservable();

  currentUserName$ = new BehaviorSubject<string>('');
  currentUserName = this.currentUserName$.asObservable();

  upgradesComplete$ = new BehaviorSubject<any>({});
  upgradesComplete = this.upgradesComplete$.asObservable();

  upgradeScreen$ = new BehaviorSubject<any>({});
  upgradeScreen = this.upgradeScreen$.asObservable();

  optionalUpgradeScreen$ = new BehaviorSubject<any>({});
  optionalUpgradeScreen = this.optionalUpgradeScreen$.asObservable();

  optionalUpgradesComplete$ = new BehaviorSubject<any>({});
  optionalUpgradesComplete = this.optionalUpgradesComplete$.asObservable();

  constructor(private busyService: BusyService) { }

  setUpgradesComplete(val: any){
    if(val[0] && val[1] && val[2])
    {
      this.upgradesComplete$.next(true);
      this.busyService.idle();
    }
  }

  showUpgradeScreen(val: any){
    if(val[0] || val[1] || val[2])
    {
      this.upgradeScreen$.next(true);
      this.busyService.idle();
    }
    else
    {
      this.upgradeScreen$.next(false);
      this.busyService.idle();
    }
  }

    setOptionalUpgradesComplete(val: any){
    if(val[0] && val[1] && val[2])
    {
      this.optionalUpgradesComplete$.next(true);
      this.busyService.idle();
    }
  }

  showOptionalUpgradeScreen(val: any){
    if(val[0] || val[1] || val[2])
    {
      this.optionalUpgradeScreen$.next(true);
      this.busyService.idle();
    }
    else
    {
      this.upgradeScreen$.next(false);
      this.busyService.idle();
    }
  }

  setSmallScreenMenu(val: any){
    this.showSmallScreenMenu$.next(val);
  }

  setKdsMode(val: boolean){
    this.kdsMode$.next(val);
  }

  setCurrentUserName(val: string){
    this.currentUserName$.next(val);
  }

  setVenueName(val: string){
    this.venueName$.next(val ?? "");
  }

  //The Auth0 token's venuename claim is a placeholder ("Not Assigned") for accounts not tied
  //to a single fixed venue - master key and shared staff logins. It is never something to
  //show, nor to store over the venue the user actually picked.
  isRealVenueName(venuename: string): boolean {
    return !!venuename && venuename.trim().toLowerCase() != "not assigned";
  }

  setUseCounters(val: string){
    this.useCounters$.next(val);
  }


  setMenuItems(val: any){
    this.menuItems$.next(val);
  }

  setBCItem(val: any){
    this.menuBCItem$.next(val);
  }

  setShowPasswordChange(val: any){
    this.ShowPasswordChange$.next(val);
  }
}
